import Api from '../../../Api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { combineReducers } from "redux";

// const getFetcher = state => {
//     return state.waas.regions.fetcher
// }
// export const fetcher = createTableFetcher('regions', Api.fetchRegions, getFetcher)

export const types = {
    SUCCESS: 'REGIONS/SUCCESS',
    EXPAND_ALL: 'REGIONS/EXPAND_ALL',
    COLLAPSE_ALL: 'REGIONS/COLLAPSE_ALL',
    TOGGLE_PANEL: 'REGIONS/TOGGLE_PANEL',
    SET_SHOULD_UPDATE: 'REGIONS/SET_SHOULD_UPDATE',
    FETCH_REGIONS: 'REGIONS/FETCH_REGIONS',
    SET_IS_LOADING: 'REGIONS/SET_IS_LOADING',
}

export const actions = {
    expandAll: () => ({ type: types.EXPAND_ALL }),
    collapseAll: () => ({ type: types.COLLAPSE_ALL }),
    success: (payload) => ({ type: types.SUCCESS, payload }),
    togglePanel: (payload) => ({ type: types.TOGGLE_PANEL, payload }),
    setShouldUpdate: (value) => ({type: types.SET_SHOULD_UPDATE, value}),
    fetchRegions: () =>  ({ type: types.FETCH_REGIONS }),
    setIsLoading: (loading) => ({type: types.SET_IS_LOADING, loading}),
    //...fetcher.actions
}

export const initialState = {
    isLoading: false,
    items: [],
    regionsPanels: {},
    regionsAppCount: {},
    regionPanelsWarningErrors: {},
    shouldUpdate: '',
}

const createRegionsPanels = (results, defaultValue = false, currentPanelState) => {
    
    var regionsPanels = {};
    Object.keys(results).forEach((region) => {
        var lbPanel = {}
        var regionExpanded = defaultValue;
        if (!regionsPanels[region])
            regionsPanels[region] = {}
            
        Object.keys(results[region]['lb']).forEach((lb) => {
            
            lbPanel[lb] = {}
            if (Object.keys(currentPanelState).length !== 0) {
                if(!currentPanelState[region])
                    currentPanelState[region] = { "expanded": defaultValue, "values": lbPanel }
                
                Object.keys(results[region]['lb'][lb].cwaf).forEach(currentCwaf => { 
                   
                    if(!currentPanelState[region].values[lb][currentCwaf])
                        lbPanel[lb][currentCwaf] = { "expanded": defaultValue } 
                    else
                        lbPanel[lb][currentCwaf] = { "expanded": currentPanelState[region].values[lb][currentCwaf].expanded } 
                });
                
                // regionsPanels[region] = { "expanded": currentPanelState[region].expanded, "values": lbPanel }
                regionExpanded = currentPanelState[region].expanded;
            }
            else {
                Object.keys(results[region]['lb'][lb].cwaf).forEach(currentCwaf => lbPanel[lb][currentCwaf] = { "expanded": defaultValue });
            }
        });
        regionsPanels[region] = { "expanded": regionExpanded, "values": lbPanel }

    });
    return regionsPanels;
}

const regionPanelsWarningErrors = (regionsPanels) => {
    var warningErrors = {};
    Object.keys(regionsPanels).forEach((region) => {
        warningErrors[region] = regionStatus(regionsPanels[region]['lb']);
    });

    return warningErrors;
}

const regionsAppCount = (regionsData) => {
    var appCount = {};
    Object.keys(regionsData).forEach((region) => {
        appCount[region] = Object.keys(regionsData[region]['lb'])
            .map((lb) =>
                regionsData[region]['lb'][lb].apps.length)
            .reduce((sum, x) =>
                sum + x, 0);
    });
    return appCount;
}

const regions = (state = initialState, action) => {
    switch (action.type) {
        case types.SUCCESS: {
            return {
                ...state,
                items: action.payload.results,
                regionsPanels: createRegionsPanels(action.payload.results, false, state.regionsPanels),
                regionPanelsWarningErrors: regionPanelsWarningErrors(action.payload.results),
                regionsAppCount: regionsAppCount(action.payload.results),
            };
        }

        case types.EXPAND_ALL: {
            return {
                ...state,
                regionsPanels: createRegionsPanels(state.items, true, {}),
                shouldUpdate: 'all'
            };
        }

        case types.COLLAPSE_ALL: {
            return {
                ...state,
                regionsPanels: createRegionsPanels(state.items, false, {}),
                shouldUpdate: 'all',
            };
        }
        
        case types.SET_SHOULD_UPDATE: {
            return {
                ...state,
                shouldUpdate: action.value,
            };
        }

        case types.TOGGLE_PANEL: {
            var shouldUpdate;
            var regionsPanels = Object.assign({}, state.regionsPanels);
            if (action.payload.type === 'REGION') {
                regionsPanels[action.payload.region].expanded = !regionsPanels[action.payload.region].expanded;
                shouldUpdate = action.payload.region;
            }
            else if (action.payload.type === 'CWAF') {
                regionsPanels[action.payload.region].values[action.payload.lb][action.payload.cwaf].expanded = !regionsPanels[action.payload.region].values[action.payload.lb][action.payload.cwaf].expanded;
                shouldUpdate = action.payload.region;
            }

            return {
                ...state,
                regionsPanels,
                shouldUpdate: shouldUpdate,
            };
        }
        case types.SET_IS_LOADING: {
            return {
                ...state,
                isLoading: action.loading,
            };
        }
        default:
            return state;
    }
}

function* fetchRegions() {
    const params = {};
    yield put(actions.setIsLoading(true));
    const payload = yield call(Api.fetchRegions, params);
    yield put(actions.success(payload));
    yield put(actions.setShouldUpdate('all'));
    yield put(actions.setIsLoading(false));
}

function regionStatus(regionData) {
    const subResults = Object.keys(regionData).map((lb) => lbStatus(regionData[lb]));
    if (subResults.includes('ERROR')) {
        return 'ERROR';
    }
    if (subResults.includes('WARNING')) {
        return 'WARNING';
    }

    return 'NORMAL'
}

function lbStatus(lb) {
    const subResults = Object.keys(lb.cwaf).map((cwafID) => {return cwafStatus(lb.cwaf[cwafID])});
    if (subResults.includes('ERROR')) {
        return 'ERROR';
    }
    if (subResults.includes('WARNING')) {
        return 'WARNING';
    }

    return 'NORMAL'
}

function cwafStatus(cwaf) {
    if (cwaf.vm_state !== 'NORMAL' && (cwaf.under_maintenance === 'FALSE' || cwaf.under_maintenance === false)) { 
        return 'ERROR';
    }
    if (cwaf.under_maintenance === 'TRUE' || cwaf.under_maintenance === true) {
        return 'WARNING';
    }
    return 'NORMAL'
}

export default combineReducers({
    regions,
});

export function* regionsSaga() {
    yield takeLatest(types.FETCH_REGIONS, fetchRegions);
}